// src/admin/pages/CategoryDetails.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { obtenerCategoriaPorId, actualizarCategoria, eliminarCategoria } from '../../api';
import ImageUploader from '../components/ImageUploader';

const tabs = ['IMAGE', 'DETAILS'];

const CategoryDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('IMAGE');

  useEffect(() => {
    const fetchCategoria = async () => {
      try {
        const data = await obtenerCategoriaPorId(id);
        setCategory(data);
      } catch (error) {
  console.error('Error loading category:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategoria();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategory((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      await actualizarCategoria(id, category);
      navigate('/admin/categories');
    } catch (error) {
  console.error('Error saving category:', error);
    }
  };

  const handleDelete = async () => {
  if (!window.confirm('Are you sure you want to delete this category?')) return;
    try {
      await eliminarCategoria(id);
      navigate('/admin/categories');
    } catch (error) {
  console.error('Error deleting category:', error);
    }
  };

  if (loading) return <div className="p-8 text-white">Loading...</div>;
  if (!category) return <div className="p-8 text-white">Category not found</div>;

  return (
    <div className="p-8 bg-[rgb(var(--color-bg))] min-h-screen text-[rgb(var(--color-text))] font-inter">
      <h1 className="text-3xl font-audiowide mb-6">Edit Category</h1>

      <div className="flex border-b border-[rgb(var(--color-border))] mb-6">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`flex items-center gap-2 px-4 py-2 text-sm font-medium transition ${
              activeTab === tab
                ? 'text-blue-400 border-b-2 border-blue-400'
                : 'text-[rgb(var(--color-text))]/70 hover:text-blue-300'
            }`}
          >
            {tab === 'IMAGE' && '📷'}
            {tab === 'DETAILS' && '📐'}
            {tab}
          </button>
        ))}
      </div>

      {activeTab === 'IMAGE' && (
        <div className="space-y-6 max-w-3xl">
          {category.imagen_url && (
            <div className="relative">
              <label className="block mb-2 text-sm text-[rgb(var(--color-text))]/80">Current image</label>
              <img
                src={category.imagen_url}
                alt="Current image"
                className="aspect-video w-full object-cover rounded-xl border border-[rgb(var(--color-border))]"
              />
              <button
                onClick={() => setCategory((prev) => ({ ...prev, imagen_url: '' }))}
                className="absolute top-2 right-2 px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-500"
              >
                Remove image
              </button>
            </div>
          )}

          <ImageUploader
            onUpload={(url) => setCategory((prev) => ({ ...prev, imagen_url: url }))}
            onReset={() => setCategory((prev) => ({ ...prev, imagen_url: '' }))}
          />
        </div>
      )}

      {activeTab === 'DETAILS' && (
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm mb-1">Name</label>
            <input
              name="nombre"
              value={category.nombre}
              onChange={handleChange}
              className="w-full p-2 bg-hover-bg border border-[rgb(var(--color-border))] rounded"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm mb-1">Description</label>
            <textarea
              name="descripcion"
              value={category.descripcion}
              onChange={handleChange}
              className="w-full h-32 p-2 bg-hover-bg border border-[rgb(var(--color-border))] rounded"
            />
          </div>
        </div>
      )}

      <div className="flex justify-between mt-10">
        <button onClick={handleDelete} className="text-red-500 hover:underline">
          🗑 Delete
        </button>
        <div className="space-x-3">
          <button
            onClick={() => navigate('/admin/categories')}
            className="px-4 py-2 bg-gray-600 rounded hover:bg-gray-500"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 text-white"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryDetails;